import React from 'react';
import DelegationItem from "../DelegationItem/DelegationItem";

const DelegationList = ({ members }) => {
    return (        
        <div 
            className="d-flex flex-column custom-scrollbar" 
            style={{ 
                gap: "12px", 
                maxHeight: "280px", 
                overflowY: "auto",
                paddingRight: "8px"
            }}
        >
            {members?.map((member) => (
                <DelegationItem key={member.id} member={member} />
            ))}
        </div>
    );
};

export default DelegationList;